<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail input-scan-page" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Work Order Execution Control Time">
		<b-card>
			<b-row>
				<b-col cols="12" lg="6">
					<app-label v-if="parentValueInfo != undefined && parentValueInfo != null && parentValueInfo != ''" label-cols-lg="12" size="sm" :label="parentLabelInfo" :model="parentValueInfo" />
				<app-input-combobox-autocomplete :options="productionControlTimeDetails" optionsLabel="standarTimeId" optionsKey="id" label-cols-lg="12" label="Production Control Time" id="input-" size="sm" :model.sync="model.productionControlTimeId"   :selected="model.productionControlTime != null ? model.productionControlTime.standarTimeId : ''" @input="getProductionControlTimeDetails" />
				<app-input-datetimepicker id="fieldset-start-control-time" label-cols-lg="12" label="Start Control Time" size="sm" :model.sync="model.startControlTime"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" />
					</b-col>
					<b-col cols="12" lg="6">
				<app-input-datetimepicker id="fieldset-stop-control-time" label-cols-lg="12" label="Stop Control Time" size="sm" :model.sync="model.stopControlTime"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" />

				</b-col>
			</b-row>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
      		<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-outline-danger float-right" @click="cancel()">
				Close
			</b-button>
      		<b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
      			<b-button size="sm" class="float-right btn-fill-success" @click="ok()">
				Save
			</b-button>
      		</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}

	@media (max-width: 576px) {
		::v-deep .modal-dialog {
			width: calc(100%) !important;
		}
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import focusInput from '@/mixins/focusInputMixin';
import WorkOrderExecutionControlTime from '@/models/WorkOrderExecution/WorkOrderExecutionControlTime';
import WorkOrderExecutionControlTimeFilter from '@/filters/WorkOrderExecution/WorkOrderExecutionControlTimeFilter';

import WorkOrderExecution from '@/models/WorkOrderExecution/WorkOrderExecution';
import WorkOrderExecutionFilter from '@/filters/WorkOrderExecution/WorkOrderExecutionFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ProductionControlTimeDetail from '@/models/ProductionControlTime/ProductionControlTimeDetail';
import ProductionControlTimeDetailFilter from '@/filters/ProductionControlTime/ProductionControlTimeDetailFilter';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import PopupRouterView from '@/components/PopupRouterView';
import AppInputScan from '@/components/AppInputScan';
export default {
	props: ['model','modelId', 'openPopup','addButtonMethod', 'resetMethod', 'parentLabelInfo', 'parentValueInfo'],
	components : {
		AppInputComboboxAutocomplete,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		PopupRouterView,
		AppInputScan,
	},
	mixins : [validationMixin, focusInput],
	validations: {
		model: {
		}
	},
	data() {
		return {
			errorMessage : {
			},
			productionControlTimeDetails : [],
			isBusy: false,
		}
	},
	methods : {
		getWorkOrderExecutionControlTime : async function(id) {
			this.isBusy = true;
			WorkOrderExecutionControlTime.getData(this, id).then(result => {
				this.model = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getProductionControlTimeDetails : async function(input) {
			let filter = new ProductionControlTimeDetailFilter();
			if (input != undefined) {
				filter.standarTimeId = input;
			}
			ProductionControlTimeDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.productionControlTimeDetails = result.data
				}
			})
			.catch(error => {});
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				let model = this.model;
				let promises = Array();
				let _this = this;
					

					
				Promise.all(promises).then((results) => {
					_this.$emit("addButtonMethod", modalEvent, _this.model); 
				});

				this.$nextTick(() => { this.$v.$reset() })
			}
		},
		resetModal() {
			this.$emit('resetMethod');
			this.$v.$reset();
		},

	},	beforeMount() {
		//this.getProductionControlTimeDetails();
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getWorkOrderExecutionControlTime(newValue);
			} else {
				this.model = {};
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getProductionControlTimeDetails();
				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getWorkOrderExecutionControlTime(this.modelId);
				}
			} else {
				this.model = {};
			}
		}
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
